<div class="task-progress" [class.compact]="compact" *ngIf="total > 0">
  <span class="task-progress-text"><span class="subtask-count">Child Cases:</span> {{ completedCount }}/{{ total }}
    completed</span>
  <div class="task-progress-bar" *ngIf="showBar">
    <div class="task-progress-fill" [style.width.%]="progressPercent"></div>
  </div>
</div>